import { CWStatus,CWRelatedEntites } from "../../Collateral/types";


export function getRelatedEntities (){
  return Object.values(CWRelatedEntites);
}

export function getEnabledStatus(collateral) {
  let allInternalStatus = Object.values(CWStatus);
  let skipItems = [];

  /*if (collateral.internalstatus == CWStatus.CustodianRequest) {
   skipItems = [CWStatus.ClientRequest];
  }
  else if (collateral.internalstatus != CWStatus.ClientRequest ) {
    skipItems = [
      CWStatus.ClientRequest, 
      CWStatus.CustodianRequest
    ];
  }
 
  if (collateral.internalstatus == CWStatus.Returned) {
    skipItems = [...skipItems, CWStatus.ReturnRequested];
  }

  allInternalStatus = allInternalStatus.filter(
    s => skipItems.includes(s) == false
  );
*/
  return allInternalStatus;
}